/**
 * GENERATED BY KRPC GEN - LESS MODIFY BY HAND
 * event-tracking-dto.ts  2025-06-05T09:42:57+08:00
 */

import {
  IsInt,
  Length,
  IsEmail,
  IsFQDN,
  IsDate,
  IsArray,
  Min,
  Max,
  IsOptional,
  IsDefined,
  IsNotEmpty,
  MinLength,
  MaxLength,
  ArrayMinSize,
  ArrayMaxSize,
  IsPositive,
  IsNegative,
} from 'class-validator'

export const APP = 'event-tracking'

export const enum EventTypeEnum {
  // 技师列表页事件
  TECH_LIST_PAGE_ENTER = 'et_techlist_page_enter',
  TECH_LIST_PAGE_BACK_CLICK = 'et_techlist_page_back_click',

  // 技师详情页事件
  TECH_DETAIL_PAGE_ENTER = 'et_techdetail_page_enter',
  TECH_DETAIL_PAGE_BACK_CLICK = 'et_techdetail_page_back_click',

  // 退款完成页事件
  REFUND_COMPLETE_PAGE_ENTER = 'et_refund_complete_page_enter',
  REFUND_COMPLETE_PAGE_BACK_CLICK = 'et_refund_complete_page_back_click',

  // 支付完成页事件
  PAYMENT_COMPLETE_PAGE_ENTER = 'et_payment_complete_page_enter',
  PAYMENT_COMPLETE_PAGE_BACK_CLICK = 'et_payment_complete_page_back_click',

  // 首页事件
  HOME_PAGE_ENTER = 'et_home_page_enter',
  HOME_PAGE_BACK_CLICK = 'et_home_page_back_click',

  // 我的页面事件
  MY_PAGE_ENTER = 'et_my_page_enter',
  MY_PAGE_BACK_CLICK = 'et_my_page_back_click',

  // 订单列表页事件
  ORDER_LIST_PAGE_ENTER = 'et_orderlist_page_enter',
  ORDER_LIST_PAGE_BACK_CLICK = 'et_orderlist_page_back_click',

  // 动态详情页（图文/视频）事件
  DYNAMIC_DETAIL_PAGE_ENTER = 'et_dynamicdetail_page_enter',
  DYNAMIC_DETAIL_PAGE_BACK_CLICK = 'et_dynamicdetail_page_back_click',

  // 视频详情页事件
  VOD_DETAIL_PAGE_ENTER = 'et_voddetail_page_enter',
  VOD_DETAIL_PAGE_BACK_CLICK = 'et_voddetail_page_back_click',
}

export class EventTrackReq {
  // 事件类型 EventTypeEnum
  @MinLength(1)
  eventType: string

  // 扩展参数
  @IsOptional()
  ext?: string

  constructor(eventType: string) {
    this.eventType = eventType
  }
}
